import { useState } from 'react';
// @mui
import { IconButton } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
// utils
import SyncIcon from '@mui/icons-material/Sync';
import { useLocation } from 'react-router-dom';
import fetchDeviceList from '../../../utils/fetchDeviceList';
import fetchStreamList from '../../../utils/fetchStreamList';
import { appSliceActions } from '../../../appSlices/appSlice';

export default function RefreshList() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const hostList = useSelector((state) => state.app.hostList);
  const handleRefresh = async () => {
    setLoading(true);
    hostList.forEach(async (host) => {
      const cameraList = await fetchDeviceList(host);
      if (cameraList != null) {
        for (let i = 0; i < cameraList.length; i += 1) {
          cameraList[i].host = host;
        }
        dispatch(appSliceActions.addDevice(cameraList));
      }
      const streamList = await fetchStreamList(host);
      if (streamList != null) {
        for (let i = 0; i < streamList.length; i += 1) {
          streamList[i].host = host;
        }
        dispatch(appSliceActions.addStream(streamList));
      }
    });
    setLoading(false);
  };
  return (
    <>
      <IconButton
        id={"refresh-list-button"}
        disabled={loading}
        color={'default'}
        onClick={async () => {
          await handleRefresh();
          if (location.pathname === '/vst/dashboard') {
            window.refreshDashboard();
          }
        }}
        sx={{ width: 40, height: 40 }}
      >
        <SyncIcon />
      </IconButton>
    </>
  );
}
